<template>
    <div class="dashboard-charts">
        <h2 class="heading">
            {{ graphHeading }}
        </h2>
        <div v-show="!noRecordFound && !showSpinner" class="chart-container">
            <div :id="id" class="amcharts-div activity-timeline-report"></div>
        </div>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>

        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import AmPie from 'amcharts3/amcharts/pie'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        legendId: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
        },
        graphHeading: {
            type: String,
            required: true,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataProvider: [],
            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        created() {
            window.AmCharts.makeChart(this.id, {
                type: 'serial',
                categoryField: 'group',
                colors: [
                    '#7F1EC5',
                    '#00A4F2',
                    '#EB8300',
                    '#0D8ECF',
                    '#2A0CD0',
                    '#CD0D74',
                    '#CC0000',
                    '#00CC00',
                    '#0000CC',
                    '#DDDDDD',
                    '#999999',
                    '#333333',
                    '#990000',
                ],
                startDuration: 1,
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                categoryAxis: {
                    gridPosition: 'start',
                    gridAlpha: 1,
                    gridColor: '#F2F2F6',
                },
                trendLines: [],
                graphs: [
                    {
                        balloonText:
                            'Total [[value]] [[title]] handled in b/w [[category]]',
                        fillAlphas: 1,
                        id: 'AmGraph-1',
                        title: 'Onboarding Alerts',
                        type: 'column',
                        valueField: 'onboarding',
                    },
                    {
                        balloonText:
                            'Total [[value]] [[title]] handled in b/w [[category]]',
                        fillAlphas: 1,
                        id: 'AmGraph-2',
                        title: 'Periodic Alerts',
                        type: 'column',
                        valueField: 'periodic',
                    },
                    {
                        balloonText:
                            'Total [[value]] [[title]] handled in b/w [[category]]',
                        fillAlphas: 1,
                        id: 'AmGraph-3',
                        title: 'Trigger Alerts',
                        type: 'column',
                        valueField: 'triggered',
                    },
                    {
                        balloonText:
                            'Total [[value]] [[title]] handled in b/w [[category]]',
                        fillAlphas: 1,
                        id: 'AmGraph-4',
                        title: 'Manual Alerts',
                        type: 'column',
                        valueField: 'manual',
                    },
                ],
                guides: [],
                valueAxes: [
                    {
                        id: 'ValueAxis-1',
                        stackType: 'regular',
                        title: 'Total Alerts',
                        gridAlpha: 1,
                        gridColor: '#F2F2F6',
                    },
                ],
                allLabels: [],
                balloon: {
                    color: '#1B1B1E',
                    fillAlpha: 1,
                },
                titles: [],
                dataProvider: this.dataProvider,
            })
        },
        async getStats() {
            try {
                this.dataProvider = []
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)

                this.showSpinner = false

                if (data && data.data) {
                    if (data.data.length) {
                        this.dataProvider = data.data
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }
                this.created()
            } catch (error) {
                this.$store.commit('setError', error)
            }
        },
    }, // End of Component > created
} // End of export default
</script>
